import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { faFile, faQuestion, faSquare } from '@fortawesome/pro-solid-svg-icons';
import { IconService, Icon } from '@dx/platform-components';

import { NavigationService } from '../../core/services/navigation.service';

@Component({
  selector: 'dx-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  randomIcon: Icon;
  faFile = faFile;
  faQuestion = faQuestion;
  faSquare = faSquare;

  constructor(public location: Location,
    private iconService: IconService,
    private navigationService: NavigationService) { }

  get goBackUrlPath() {
    return this.navigationService.previousUrlPath;
  }

  get goBackUrlParams() {
    return this.navigationService.previousUrlParams;
  }

  get goBackName() {
    return this.navigationService.previousTitle;
  }

  get path() {
    return (this.navigationService.currentUrlPath !== '/404') ? this.location.path() : '';
  }

  ngOnInit() {
    this.randomIcon = this.iconService.randomIcon();
  }
}
